"use strict";
/* eslint-disable max-lines */
exports.__esModule = true;
exports.spacings = exports.shadows = exports.opacityColors = exports.colors = exports.roundings = exports.opacities = exports.fonts = void 0;
exports.fonts = {
    'font-base': "Roboto, apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif"
};
exports.opacities = {
    'opacity-4': "0.4",
    'opacity-6': "0.6",
    'opacity-8': "0.8"
};
exports.roundings = {
    'rounding-m': "4px",
    'rounding-l': "8px",
    'rounding-xl': "16px"
};
exports.colors = {
    'text-primary': "#333333",
    'text-secondary': "#666666",
    'text-minor': "#999999",
    'text-invert': "#FFFFFF",
    'background-accent': "#2E323D",
    'background-secondary': "#F2F3F5",
    'background-primary': "#FFFFFF",
    'control-primary': "#464C5C",
    'control-secondary': "#CED0D6",
    'control-minor': "#E8E9EB",
    'control-invert': "#FFFFFF",
    'control-secondary-invert': "rgba(255, 255, 255, 0.4)",
    'control-minor-invert': "rgba(255, 255, 255, 0.16)",
    'control_hover-primary': "#1C212E",
    'control_hover-secondary': "#A9ADB8",
    'control_hover-minor': "#DCDDE0",
    'control_hover-primary-invert': "rgba(255, 255, 255, 0.92)",
    'control_hover-secondary-invert': "rgba(255, 255, 255, 0.5)",
    'control_hover-minor-invert': "rgba(255, 255, 255, 0.24)",
    'success-primary': "#5AB030",
    'success-dark': "#488C26",
    'success-light': "#DEEFD5",
    'brand-primary': "#5AB030",
    'brand-dark': "#488C26",
    'brand-light': "#DEEFD5",
    'brand-minor': "#000000",
    'brand-invert': "#FFFFFF",
    'accent-primary': "#F4BE55",
    'accent-dark': "#C39844",
    'accent-light': "#FCF2DD",
    'attention-primary': "#E6615E",
    'attention-dark': "#B84D4B",
    'attention-light': "#FADFDE",
    'secondary-green_primary': "#00B2A9",
    'secondary-green_dark': "#008E87",
    'secondary-green_light': "#CCEFED",
    'secondary-blue_primary': "#3D6BE3",
    'secondary-blue_dark': "#3B59A4",
    'secondary-blue_light': "#D1DEFF",
    'secondary-orange_primary': "#D95E00",
    'secondary-orange_dark': "#AD4B00",
    'secondary-orange_light': "#F7DECC",
    'secondary-purple_primary': "#8961A5",
    'secondary-purple_dark': "#6D4D84",
    'secondary-purple_light': "#E7DFED",
    'secondary-yellow_primary': "#FFE55A",
    'secondary-yellow_dark': "#CCB748",
    'secondary-yellow_light': "#FFF9DE"
};
exports.opacityColors = {
    'text-primary_opacity-4': "rgba(51, 51, 51, 0.4)",
    'text-primary_opacity-6': "rgba(51, 51, 51, 0.6)",
    'text-primary_opacity-8': "rgba(51, 51, 51, 0.8)",
    'text-secondary_opacity-4': "rgba(102, 102, 102, 0.4)",
    'text-secondary_opacity-6': "rgba(102, 102, 102, 0.6)",
    'text-secondary_opacity-8': "rgba(102, 102, 102, 0.8)",
    'text-minor_opacity-4': "rgba(153, 153, 153, 0.4)",
    'text-minor_opacity-6': "rgba(153, 153, 153, 0.6)",
    'text-minor_opacity-8': "rgba(153, 153, 153, 0.8)",
    'text-invert_opacity-4': "rgba(255, 255, 255, 0.4)",
    'text-invert_opacity-6': "rgba(255, 255, 255, 0.6)",
    'text-invert_opacity-8': "rgba(255, 255, 255, 0.8)",
    'background-accent_opacity-4': "rgba(46, 50, 61, 0.4)",
    'background-accent_opacity-6': "rgba(46, 50, 61, 0.6)",
    'background-accent_opacity-8': "rgba(46, 50, 61, 0.8)",
    'background-secondary_opacity-4': "rgba(242, 243, 245, 0.4)",
    'background-secondary_opacity-6': "rgba(242, 243, 245, 0.6)",
    'background-secondary_opacity-8': "rgba(242, 243, 245, 0.8)",
    'background-primary_opacity-4': "rgba(255, 255, 255, 0.4)",
    'background-primary_opacity-6': "rgba(255, 255, 255, 0.6)",
    'background-primary_opacity-8': "rgba(255, 255, 255, 0.8)",
    'control-primary_opacity-4': "rgba(70, 76, 92, 0.4)",
    'control-primary_opacity-6': "rgba(70, 76, 92, 0.6)",
    'control-primary_opacity-8': "rgba(70, 76, 92, 0.8)",
    'control-secondary_opacity-4': "rgba(206, 208, 214, 0.4)",
    'control-secondary_opacity-6': "rgba(206, 208, 214, 0.6)",
    'control-secondary_opacity-8': "rgba(206, 208, 214, 0.8)",
    'control-minor_opacity-4': "rgba(232, 233, 235, 0.4)",
    'control-minor_opacity-6': "rgba(232, 233, 235, 0.6)",
    'control-minor_opacity-8': "rgba(232, 233, 235, 0.8)",
    'control-invert_opacity-4': "rgba(255, 255, 255, 0.4)",
    'control-invert_opacity-6': "rgba(255, 255, 255, 0.6)",
    'control-invert_opacity-8': "rgba(255, 255, 255, 0.8)",
    'control-secondary-invert_opacity-4': "rgba(255, 255, 255, 0.16000000000000003)",
    'control-secondary-invert_opacity-6': "rgba(255, 255, 255, 0.24)",
    'control-secondary-invert_opacity-8': "rgba(255, 255, 255, 0.32000000000000006)",
    'control-minor-invert_opacity-4': "rgba(255, 255, 255, 0.064)",
    'control-minor-invert_opacity-6': "rgba(255, 255, 255, 0.096)",
    'control-minor-invert_opacity-8': "rgba(255, 255, 255, 0.128)",
    'control_hover-primary_opacity-4': "rgba(28, 33, 46, 0.4)",
    'control_hover-primary_opacity-6': "rgba(28, 33, 46, 0.6)",
    'control_hover-primary_opacity-8': "rgba(28, 33, 46, 0.8)",
    'control_hover-secondary_opacity-4': "rgba(169, 173, 184, 0.4)",
    'control_hover-secondary_opacity-6': "rgba(169, 173, 184, 0.6)",
    'control_hover-secondary_opacity-8': "rgba(169, 173, 184, 0.8)",
    'control_hover-minor_opacity-4': "rgba(220, 221, 224, 0.4)",
    'control_hover-minor_opacity-6': "rgba(220, 221, 224, 0.6)",
    'control_hover-minor_opacity-8': "rgba(220, 221, 224, 0.8)",
    'control_hover-primary-invert_opacity-4': "rgba(255, 255, 255, 0.36800000000000005)",
    'control_hover-primary-invert_opacity-6': "rgba(255, 255, 255, 0.552)",
    'control_hover-primary-invert_opacity-8': "rgba(255, 255, 255, 0.7360000000000001)",
    'control_hover-secondary-invert_opacity-4': "rgba(255, 255, 255, 0.2)",
    'control_hover-secondary-invert_opacity-6': "rgba(255, 255, 255, 0.3)",
    'control_hover-secondary-invert_opacity-8': "rgba(255, 255, 255, 0.4)",
    'control_hover-minor-invert_opacity-4': "rgba(255, 255, 255, 0.096)",
    'control_hover-minor-invert_opacity-6': "rgba(255, 255, 255, 0.144)",
    'control_hover-minor-invert_opacity-8': "rgba(255, 255, 255, 0.192)",
    'success-primary_opacity-4': "rgba(90, 176, 48, 0.4)",
    'success-primary_opacity-6': "rgba(90, 176, 48, 0.6)",
    'success-primary_opacity-8': "rgba(90, 176, 48, 0.8)",
    'success-dark_opacity-4': "rgba(72, 140, 38, 0.4)",
    'success-dark_opacity-6': "rgba(72, 140, 38, 0.6)",
    'success-dark_opacity-8': "rgba(72, 140, 38, 0.8)",
    'success-light_opacity-4': "rgba(222, 239, 213, 0.4)",
    'success-light_opacity-6': "rgba(222, 239, 213, 0.6)",
    'success-light_opacity-8': "rgba(222, 239, 213, 0.8)",
    'brand-primary_opacity-4': "rgba(90, 176, 48, 0.4)",
    'brand-primary_opacity-6': "rgba(90, 176, 48, 0.6)",
    'brand-primary_opacity-8': "rgba(90, 176, 48, 0.8)",
    'brand-dark_opacity-4': "rgba(72, 140, 38, 0.4)",
    'brand-dark_opacity-6': "rgba(72, 140, 38, 0.6)",
    'brand-dark_opacity-8': "rgba(72, 140, 38, 0.8)",
    'brand-light_opacity-4': "rgba(222, 239, 213, 0.4)",
    'brand-light_opacity-6': "rgba(222, 239, 213, 0.6)",
    'brand-light_opacity-8': "rgba(222, 239, 213, 0.8)",
    'brand-minor_opacity-4': "rgba(0, 0, 0, 0.4)",
    'brand-minor_opacity-6': "rgba(0, 0, 0, 0.6)",
    'brand-minor_opacity-8': "rgba(0, 0, 0, 0.8)",
    'brand-invert_opacity-4': "rgba(255, 255, 255, 0.4)",
    'brand-invert_opacity-6': "rgba(255, 255, 255, 0.6)",
    'brand-invert_opacity-8': "rgba(255, 255, 255, 0.8)",
    'accent-primary_opacity-4': "rgba(244, 190, 85, 0.4)",
    'accent-primary_opacity-6': "rgba(244, 190, 85, 0.6)",
    'accent-primary_opacity-8': "rgba(244, 190, 85, 0.8)",
    'accent-dark_opacity-4': "rgba(195, 152, 68, 0.4)",
    'accent-dark_opacity-6': "rgba(195, 152, 68, 0.6)",
    'accent-dark_opacity-8': "rgba(195, 152, 68, 0.8)",
    'accent-light_opacity-4': "rgba(252, 242, 221, 0.4)",
    'accent-light_opacity-6': "rgba(252, 242, 221, 0.6)",
    'accent-light_opacity-8': "rgba(252, 242, 221, 0.8)",
    'attention-primary_opacity-4': "rgba(230, 97, 94, 0.4)",
    'attention-primary_opacity-6': "rgba(230, 97, 94, 0.6)",
    'attention-primary_opacity-8': "rgba(230, 97, 94, 0.8)",
    'attention-dark_opacity-4': "rgba(184, 77, 75, 0.4)",
    'attention-dark_opacity-6': "rgba(184, 77, 75, 0.6)",
    'attention-dark_opacity-8': "rgba(184, 77, 75, 0.8)",
    'attention-light_opacity-4': "rgba(250, 223, 222, 0.4)",
    'attention-light_opacity-6': "rgba(250, 223, 222, 0.6)",
    'attention-light_opacity-8': "rgba(250, 223, 222, 0.8)",
    'secondary-green_primary_opacity-4': "rgba(0, 178, 169, 0.4)",
    'secondary-green_primary_opacity-6': "rgba(0, 178, 169, 0.6)",
    'secondary-green_primary_opacity-8': "rgba(0, 178, 169, 0.8)",
    'secondary-green_dark_opacity-4': "rgba(0, 142, 135, 0.4)",
    'secondary-green_dark_opacity-6': "rgba(0, 142, 135, 0.6)",
    'secondary-green_dark_opacity-8': "rgba(0, 142, 135, 0.8)",
    'secondary-green_light_opacity-4': "rgba(204, 239, 237, 0.4)",
    'secondary-green_light_opacity-6': "rgba(204, 239, 237, 0.6)",
    'secondary-green_light_opacity-8': "rgba(204, 239, 237, 0.8)",
    'secondary-blue_primary_opacity-4': "rgba(61, 107, 227, 0.4)",
    'secondary-blue_primary_opacity-6': "rgba(61, 107, 227, 0.6)",
    'secondary-blue_primary_opacity-8': "rgba(61, 107, 227, 0.8)",
    'secondary-blue_dark_opacity-4': "rgba(59, 89, 164, 0.4)",
    'secondary-blue_dark_opacity-6': "rgba(59, 89, 164, 0.6)",
    'secondary-blue_dark_opacity-8': "rgba(59, 89, 164, 0.8)",
    'secondary-blue_light_opacity-4': "rgba(209, 222, 255, 0.4)",
    'secondary-blue_light_opacity-6': "rgba(209, 222, 255, 0.6)",
    'secondary-blue_light_opacity-8': "rgba(209, 222, 255, 0.8)",
    'secondary-orange_primary_opacity-4': "rgba(217, 94, 0, 0.4)",
    'secondary-orange_primary_opacity-6': "rgba(217, 94, 0, 0.6)",
    'secondary-orange_primary_opacity-8': "rgba(217, 94, 0, 0.8)",
    'secondary-orange_dark_opacity-4': "rgba(173, 75, 0, 0.4)",
    'secondary-orange_dark_opacity-6': "rgba(173, 75, 0, 0.6)",
    'secondary-orange_dark_opacity-8': "rgba(173, 75, 0, 0.8)",
    'secondary-orange_light_opacity-4': "rgba(247, 222, 204, 0.4)",
    'secondary-orange_light_opacity-6': "rgba(247, 222, 204, 0.6)",
    'secondary-orange_light_opacity-8': "rgba(247, 222, 204, 0.8)",
    'secondary-purple_primary_opacity-4': "rgba(137, 97, 165, 0.4)",
    'secondary-purple_primary_opacity-6': "rgba(137, 97, 165, 0.6)",
    'secondary-purple_primary_opacity-8': "rgba(137, 97, 165, 0.8)",
    'secondary-purple_dark_opacity-4': "rgba(109, 77, 132, 0.4)",
    'secondary-purple_dark_opacity-6': "rgba(109, 77, 132, 0.6)",
    'secondary-purple_dark_opacity-8': "rgba(109, 77, 132, 0.8)",
    'secondary-purple_light_opacity-4': "rgba(231, 223, 237, 0.4)",
    'secondary-purple_light_opacity-6': "rgba(231, 223, 237, 0.6)",
    'secondary-purple_light_opacity-8': "rgba(231, 223, 237, 0.8)",
    'secondary-yellow_primary_opacity-4': "rgba(255, 229, 90, 0.4)",
    'secondary-yellow_primary_opacity-6': "rgba(255, 229, 90, 0.6)",
    'secondary-yellow_primary_opacity-8': "rgba(255, 229, 90, 0.8)",
    'secondary-yellow_dark_opacity-4': "rgba(204, 183, 72, 0.4)",
    'secondary-yellow_dark_opacity-6': "rgba(204, 183, 72, 0.6)",
    'secondary-yellow_dark_opacity-8': "rgba(204, 183, 72, 0.8)",
    'secondary-yellow_light_opacity-4': "rgba(255, 249, 222, 0.4)",
    'secondary-yellow_light_opacity-6': "rgba(255, 249, 222, 0.6)",
    'secondary-yellow_light_opacity-8': "rgba(255, 249, 222, 0.8)"
};
exports.shadows = {
    'box-shadow-m': "\n  0 1.17px 2px rgba(0, 0, 0, 0.0196802),\n  0 1.4px 5px rgba(0, 0, 0, 0.03),\n  0 2px 10px rgba(0, 0, 0, 0.03),\n  0 2px 18px rgba(0, 0, 0, 0.04),\n  0 9px 33px rgba(0, 0, 0, 0.03),\n",
    'box-shadow-m-up': "\n  0 -1.17px 2px rgba(0, 0, 0, 0.0196802),\n  0 -1.4px 5px rgba(0, 0, 0, 0.03),\n  0 -2px 10px rgba(0, 0, 0, 0.03),\n  0 -2px 18px rgba(0, 0, 0, 0.04),\n  0 -9px 33px rgba(0, 0, 0, 0.03),\n",
    'box-shadow-s': "\n  0 1px 4px rgba(0, 0, 0, 0.16),\n  0 2px 9px rgba(0, 0, 0, 0.02),\n",
    'box-shadow-s-up': "\n  0 -1px 4px rgba(0, 0, 0, 0.16),\n  0 -2px 9px rgba(0, 0, 0, 0.02),\n",
    'box-shadow-l': "\n  0 0.166035px 2.21381px rgba(0, 0, 0, 0.0196802),\n  0 0.399006px 5.32008px rgba(0, 0, 0, 0.0282725),\n  0 0.751293px 10.0172px rgba(0, 0, 0, 0.035),\n  0 12px 40px rgba(0, 0, 0, 0.08),\n",
    'box-shadow-l-up': "\n  0 -0.166035px 2.21381px rgba(0, 0, 0, 0.0196802),\n  0 -0.399006px 5.32008px rgba(0, 0, 0, 0.0282725),\n  0 -0.751293px 10.0172px rgba(0, 0, 0, 0.035),\n  0 -12px 40px rgba(0, 0, 0, 0.08),\n"
};
exports.spacings = {
    'space-10': "1px",
    'space-25': "2px",
    'space-35': "3px",
    'space-50': "4px",
    'space-60': "5px",
    'space-75': "6px",
    'space-85': "7px",
    'space-100': "8px",
    'space-125': "10px",
    'space-150': "12px",
    'space-175': "14px",
    'space-200': "16px",
    'space-225': "18px",
    'space-250': "20px",
    'space-275': "22px",
    'space-300': "24px",
    'space-325': "26px",
    'space-350': "28px",
    'space-375': "30px",
    'space-400': "32px",
    'space-425': "34px",
    'space-450': "36px",
    'space-475': "38px",
    'space-500': "40px",
    'space-525': "42px",
    'space-550': "44px",
    'space-575': "46px",
    'space-600': "48px",
    'space-625': "50px",
    'space-650': "52px",
    'space-675': "54px",
    'space-700': "56px",
    'space-725': "58px",
    'space-750': "60px",
    'space-775': "62px",
    'space-800': "64px",
    'space-825': "66px",
    'space-850': "68px",
    'space-875': "70px",
    'space-900': "72px",
    'space-925': "74px",
    'space-950': "76px",
    'space-975': "78px",
    'space-1000': "80px"
};
